<div class="seb-banner animate__animated animate__fadeInUp" *ngIf="visible">

  <div class="seb-icon-wrap">
    <ion-icon name="time-outline" class="seb-icon"></ion-icon>
  </div>

  <div class="seb-text">
    <p class="seb-title">Session expiring soon</p>
    <p class="seb-countdown">{{ countdownLabel }}</p>
  </div>

  <ion-button
    size="small"
    fill="solid"
    color="primary"
    class="seb-action-btn"
    [disabled]="isRefreshing"
    (click)="extendSession()">
    <ion-spinner *ngIf="isRefreshing" name="crescent" class="seb-spinner"></ion-spinner>
    <span *ngIf="!isRefreshing">Stay signed in</span>
  </ion-button>

  <ion-button
    fill="clear"
    class="seb-dismiss-btn"
    aria-label="Dismiss"
    [disabled]="isRefreshing"
    (click)="dismiss()">
    <ion-icon slot="icon-only" name="close-outline"></ion-icon>
  </ion-button>

</div>
